import { useRef } from "react";
import "./IntroVideoModal.css";

export default function IntroVideoModal({ open, onClose }) {
  const videoRef = useRef(null);

  const closeModal = () => {
    videoRef.current?.pause();
    onClose();
  };

  if (!open) return null;

  return (
    <div className="intro-video-overlay">
      <div className="intro-video-modal">
        <button
          className="intro-close-btn"
          onClick={closeModal}
          aria-label="Close intro video"
        >
          ✕
        </button>
        <video ref={videoRef} controls autoPlay>
          <source src="/intro.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
}
